import { ISourcingToolSearchFilter } from "react-migration/domains/search/typings/SourcingToolSpecificFilterTypes";
import { SearchType } from "react-migration/domains/search/constants/searchTypes";
import { ConstrainedListFilterMust } from "react-migration/domains/search/typings/SourcingToolFilters/types";

export const RegenerationZonesAdoptedFilter: ISourcingToolSearchFilter = {
  id: "regeneration-zones-adopted-id",
  type: "checkbox",
  field: "sidebar.react.search_sidebar.regeneration_zones_adopted",
  must: ConstrainedListFilterMust.MATCH_ANY,
  mustOptions: [ConstrainedListFilterMust.MATCH_ANY, ConstrainedListFilterMust.MATCH_NONE],
  updateFilterDialogIsVisible: false,
  searchTypes: [SearchType.SOURCING_TOOL_UK],
  values: [
    {
      key: "area_action_plans",
      name: "Area Action Plans",
      checked: true,
    },
    {
      key: "named_regeneration_areas",
      name: "Named Regeneration Areas",
    },
  ],
};
